import { getFingerPrint } from "./finger";
import LayerListener from "./listener";
import { handleSessionId } from "./sessionId";
import { initCommonParamStorage } from "./commonParam";
import { UPLOAD_TYPE } from "./define";

const officialGuideListener = new LayerListener(
  "officialGuideDataLayer",
  UPLOAD_TYPE.officialGuide
);

const initCommonParams = () => {
  getFingerPrint();

  try {
    initCommonParamStorage();
  } catch (e) {
    console.log(e);
  }
};

export const initBiPoint = ({ dataLayerName, needInitCommonParams = true }) => {
  needInitCommonParams && initCommonParams();
  handleSessionId(dataLayerName);
};
